"use strict";
/*
 * Created on 04 09 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * Serialization/deserialization of of {@link SelloutReleaseItemWithPart}.
 *
 * @author JMe
 */


var SelloutReleaseItemWithPartConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SelloutReleaseItemWithPartConverter, _DataObjectConverter_);

  function SelloutReleaseItemWithPartConverter() {
    _classCallCheck(this, SelloutReleaseItemWithPartConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseItemWithPartConverter).apply(this, arguments));
  }

  return SelloutReleaseItemWithPartConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SelloutReleaseItemWithPartConverter = SelloutReleaseItemWithPartConverter;